<script setup lang="ts">
import type { TransitionDescriptor } from '~/utils/event-policy';

defineProps<{
  modelValue: boolean;
  transition: TransitionDescriptor | null;
  isLoading: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  confirm: [];
}>();
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    max-width="480"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card v-if="transition">
      <v-card-title class="text-h6">
        {{ transition.label }}
      </v-card-title>
      <v-card-text>
        {{ transition.confirmationMessage }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          :disabled="isLoading"
          @click="emit('update:modelValue', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          :color="transition.variant"
          variant="flat"
          :loading="isLoading"
          @click="emit('confirm')"
        >
          {{ transition.label }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
